import { certificatePemBlocks } from "../../../shared/connectors/caCertificate";
import { parseX509Certificate } from "../../../shared/tunnel/cert";

export async function validCaCertificateUpload(
  value: string
): Promise<boolean> {
  const certificates = certificatePemBlocks(value);
  if (!certificates) return false;
  try {
    for (const certificate of certificates)
      await parseX509Certificate(certificate);
    return true;
  } catch {
    return false;
  }
}
